import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('fieldDetailsPage');

    return {
        APPLICATIONS: t('applications'),
        EDIT_FIELD: t('editField'),
        LINKED_ENTITIES: t('linkedEntities')
    };
};

export default useTranslation;
